var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Outlined / Building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.388916 12.9641V1.05005H6.92666V3.74014H13.6111V12.9641H0.388916ZM1.4568 11.8962H3.16868V10.1843H1.4568V11.8962ZM1.4568 9.20609H3.16868V7.49421H1.4568V9.20609ZM1.4568 6.516H3.16868V4.80412H1.4568V6.516ZM1.4568 3.8259H3.16868V2.11402H1.4568V3.8259ZM4.1469 11.8962H5.85877V10.1843H4.1469V11.8962ZM4.1469 9.20609H5.85877V7.49421H4.1469V9.20609ZM4.1469 6.516H5.85877V4.80412H4.1469V6.516ZM4.1469 3.8259H5.85877V2.11402H4.1469V3.8259ZM6.83699 11.8962H12.5433V4.80412H6.83699V6.516H8.14128V7.49421H6.83699V9.20609H8.14128V10.1843H6.83699V11.8962ZM9.85316 7.49421V6.516H10.8314V7.49421H9.85316ZM9.85316 10.1843V9.20609H10.8314V10.1843H9.85316Z",
    fill: "#2B59C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.df30ec053c8ab911414f736cb574574d.svg";
export { ForwardRef as ReactComponent };